/* hs-eslint ignored failing-rules */

import { createSelector } from 'reselect';
import Scopes from '../constants/Scopes';
import { gate } from 'hub-http/gates';
const getGates = state => state.auth.gates;
export const getUser = state => state.auth.user;
export const getScopes = createSelector([getUser], user => {
  return user.scopes || [];
});
export const getUserLocale = createSelector([getUser], user => {
  return user.locale || 'en';
});
export const getIsUngated = createSelector([getGates], gates => gateToBeChecked => gates.includes(gateToBeChecked));
export const getHasScope = createSelector([getScopes], scopes => scope => scopes.includes(scope));
export const getHasAccess = createSelector([getHasScope], hasScope => hasScope(Scopes.THEME_WRITE_ACCESS));
export const getIsHubSpotter = createSelector([getUser], ({
  email = ''
}) => email.endsWith('@hubspot.com'));
export const getHasDesignManagerAccessScope = createSelector([getHasScope], hasScope => hasScope(Scopes.DESIGN_MANAGER_ACCESS));
export const getHasAdvancedLandingPagesWriteAccess = createSelector([getHasScope], hasScope => hasScope(Scopes.LANDINGPAGES_ADVANCED_WRITE) && hasScope(Scopes.LANDINGPAGES_ACCESS));
export const getHasSitePagesWriteAccess = createSelector([getHasScope], hasScope => hasScope(Scopes.PAGES_WRITE) && hasScope(Scopes.SITEPAGES_ACCESS));
export const getHasBlogWriteAccess = createSelector([getHasScope], hasScope => hasScope(Scopes.BLOG_WRITE) && hasScope(Scopes.BLOG_ACCESS));
export const getHasAccountTrust = createSelector([getHasScope], hasScope => hasScope(Scopes.LANDINGPAGES_TRUSTED));
export const getHasMultiDomainPublishAccess = createSelector([getHasScope], hasScope => hasScope(Scopes.MULTI_DOMAIN_PUBLISHING_ACCESS));
export const getHasBrandedThemePresetsAccessScope = createSelector([getHasScope], hasScope => hasScope(Scopes.BRANDED_THEME_PRESETS_ACCESS));
export const getHasThemePresetsAccessScope = createSelector([getHasScope, getHasBrandedThemePresetsAccessScope], (hasScope, hasBrandedThemePresetsAccessScope) => hasScope(Scopes.THEME_PRESETS_ACCESS) || hasBrandedThemePresetsAccessScope);
export const getIsUngatedForUniversalThemeEditing = createSelector([getIsUngated], isUngated => isUngated(gate('UniversalThemeEditor')));
export const getHasBrandSettingsViewAccess = createSelector([getHasScope], hasScope => hasScope(Scopes.BRAND_SETTINGS_VIEW));